import React from "react";

const AboutSection = () => {
  return (
    <section className="prt-row about-section01 clearfix">
      <div className="container">
        {/* Row One */}
        <div className="row">
          <div className="col-xl-12">
            <div className="tm-scrollintetx-wrapper Frist">
              <div className="big-title"> Conócenos </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
            <div className="section-title res-991-mb-0">
              <div className="title-header">
                <h2 className="title">
                  <span className="title-heading-underline">Naturopatía</span> alimentaria, psicología y hábitos saludables.
                </h2>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
            <div className="div-block-22">
              <h3 className="desc-heading">
                Salud integral, Bienestar integral, Naturopatía, Psicología y Servicios Corporativos
              </h3>
              <p className="desc-text">
                En EquipoMAG apostamos por una alimentación completa y un enfoque integral para el bienestar.
                Nuestro equipo de expertos te ofrece asesoramiento personalizado en naturopatía alimentaria,
                apoyo psicológico y soluciones para empresas, adaptando cada plan a tus necesidades.
              </p>
            </div>
          </div>
        </div>
        {/* Row Two */}
        <div className="row mt-30 res-1199-mt-15">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <div className="mt_50 res-1199-mt_20">
              <div className="prt-fid inside style2">
                <div className="prt-fid-contents">
                  <h4 className="prt-fid-inner">
                    <span
                      data-appear-animation="animateDigits"
                      data-from="0"
                      data-to="25"
                      data-interval="6"
                      data-before=""
                      data-before-style="sup"
                      data-after=""
                      data-after-style="sub"
                      className="numinate"
                    >
                      8
                    </span>
                    <span>+</span>
                  </h4>
                  <p className="prt-fid-title">años de experiencia</p>
                </div>
              </div>
              <div className="mt-25 res-991-mt-0">
                <img
                  width="635"
                  height="571"
                  src="/assets/images/single-img-4.png"
                  className="img-fluid"
                  alt="experience"
                />
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <div className="res-1199-mt-30">
              <img
                width="635"
                height="658"
                src="/assets/images/single-img-5.png"
                className="img-fluid"
                alt="about"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
